import React from "react";

const ChannelLogo = ({ partnerLogoUrl, showPartner }) => (
  <div className={`channel-logo${showPartner && partnerLogoUrl ? " partnered" : ""}`}>
    <img
      className="mozrest-logo"
      src="https://mozrest-statics.s3.eu-west-1.amazonaws.com/logos/logo.svg"
      alt="Mozrest"
    />
    {showPartner && partnerLogoUrl && (
      <div className="partner-block" aria-label="In partnership with">
        <span className="partner-separator" aria-hidden="true" />
        <span className="partner-text">In partnership with</span>
        <img className="partner-logo" src={partnerLogoUrl} alt="Partner" />
      </div>
    )}
  </div>
);

export default ChannelLogo;